var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 14l7-7-7-7-1.237 1.237 4.884 4.904H0v1.718h10.647l-4.884 4.904z","fill-rule":"nonzero"}})])}
var staticRenderFns = []

export { render, staticRenderFns }